module.exports = __webpack_public_path__ + "img/mainlogo.d9002255.jpg";